<ng-template #tooltipTemplate let-anchor>
   <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>
<kendo-grid
   samwebPersistKendoGrid
   samwebVirtualScrollKendoGrid
   kendoTooltip
   style="height: 100%"
   [virtualScrollData]="skillList$ | async"
   [virtualScrollBufferTime]="'0'"
   [columnMenu]="true"
   [sortable]="false"
   [resizable]="true"
   [reorderable]="true"
   (selectionChange)="onSelectionChange($event)"
   [selectable]="{
      mode: 'single'
   }"
   kendoGridSelectBy="skillId"
   [selectedKeys]="selectedKeys$ | async"
   showOn="none"
   [tooltipTemplate]="tooltipTemplate"
   #cellTooltipDirective="kendoTooltip"
   filter=".k-grid td"
   (mouseover)="showTooltip($event)"
   (mouseout)="hideTooltip()"
>
   <kendo-grid-column
      field="currentUiPosition"
      [title]="'brick.brick_definitions.skill-browser.columns.logon.title' | translate"
   >
      <ng-template kendoGridCellTemplate let-dataItem>
         <samweb-skill-active-state-checkbox
            [brickInstanceId]="brickInstanceId"
            [userId]="userId"
            [skillGroup]="dataItem"
            [disabled]="!(isUserLoggedOn$ | async)"
            (activeStateChanged)="changeSkillStatus(dataItem.skills, $event)"
         >
         </samweb-skill-active-state-checkbox>
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column
      field="skillConfiguration"
      [title]="'brick.brick_definitions.skill-browser.columns.skill.title' | translate"
      [style]="{ 'line-height': '10%' }"
   >
      <ng-template kendoGridCellTemplate let-dataItem>
         <samweb-skill-short-info
            *ngIf="dataItem.skillConfiguration"
            [skillConfiguration]="dataItem.skillConfiguration"
            [skills]="dataItem.skills"
         ></samweb-skill-short-info>
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column
      field="agentsReadyCount"
      [title]="'brick.brick_definitions.skill-browser.columns.sumusers.title' | translate"
      [style]="{ 'text-align': 'right', 'line-height': '100%' }"
   >
      <ng-template kendoGridCellTemplate let-dataItem>
         {{ dataItem.loggedOnUserIds?.length }}
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column
      field="waitCount"
      [title]="'brick.brick_definitions.skill-browser.columns.sumconvs.title' | translate"
      [style]="{ 'text-align': 'right', 'line-height': '100%' }"
   >
      <ng-template kendoGridCellTemplate let-dataItem>
         {{ dataItem.waitCount }}
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column
      field="callTimeStamp"
      [title]="'brick.brick_definitions.skill-browser.columns.wait.title' | translate"
      [style]="{ 'text-align': 'right', 'line-height': '100%' }"
   >
      <ng-template kendoGridCellTemplate let-dataItem>
         <ng-container *ngIf="dataItem.oldestCallTimeStamp">
            {{ dataItem.oldestCallTimeStamp | amTimeAgoUpdateEverySecond$ | durationToText$ | async }}
         </ng-container>
      </ng-template>
   </kendo-grid-column>

   <kendo-grid-column
      field="redirection"
      [title]="'brick.brick_definitions.skill-browser.columns.diversion.title' | translate"
   >
      <ng-template kendoGridCellTemplate let-dataItem>
         <ng-template #forwardSkillTooltip>
            <div style="align-content: center; margin: 5px" *ngFor="let skill of dataItem.skills">
               <ng-container *ngIf="skill.skillId | isSkillDiversionAllowed | async">
                  {{ 'brick.brick_definitions.skill-browser.diversion_tooltip' | translate }}
               </ng-container>
            </div>
         </ng-template>
         <ng-template #redirectAddressTooltip>
            <div class="sam-margin" (samwebOutsideClick)="closeRedirectSkillPopup()" [style.width]="'250px'">
               <samweb-skill-diversion-dialog
                  [skills]="dataItem.skills"
                  [brickInstanceId]="brickInstanceId"
                  (skillDiversionDialogFinished)="closeRedirectSkillPopup()"
                  class="sam-full-width"
               ></samweb-skill-diversion-dialog>
            </div>
         </ng-template>
         <div kendoTooltip [tooltipTemplate]="forwardSkillTooltip" filter="button" position="right">
            <span
               fxFlex="1 1 *"
               fxFlexAlign="center"
               class="k-text-ellipsis callable"
               (click)="call(dataItem.redirectionAddress)"
            >
               {{ dataItem.redirectionAddress }}
            </span>
            <button
               [disabled]="!(dataItem.skillId | isSkillDiversionAllowed | async)"
               kendoButton
               kendoTooltip
               [tooltipTemplate]="redirectAddressTooltip"
               tooltipClass="tooltip-popup"
               (click)="openRedirectSkillPopup(dataItem)"
               [isTooltipVisible]="(skillIdForRedirectionAddressDialog$ | async) === dataItem.skillId"
            >
               <fa-icon [icon]="redirectionIcon"></fa-icon>
            </button>
         </div>
      </ng-template>
   </kendo-grid-column>
</kendo-grid>
